__turbopack_context__.v({
  "loading-button": "marketplace-sticky-footer-content-module-scss-module__nFQcbq__loading-button",
});
